import { fetchUserDetails } from "@/api/index";
const actions = {
  /**
   * LOGIN
   */
  LOGIN({ commit }, data) {
    window.console.log("ACTION LOGIN data", data);
    commit("LOGIN", data);
    window.location.href = "/";
  },
  /*
   * LOGOUT
   */
  LOGOUT({ commit }) {
    localStorage.removeItem("accesstoken");
    commit("LOGOUT");
    window.location.href = "/";
  },

  /**
   * 유저 정보 상세정보
   */
  getAccountInfo({ commit }) {
    fetchUserDetails().then((res) => {
      window.console.log("getAccountInfo : res", res);
      if (res.status == 200) {
        let userInfo = {
          id: res.data.data.id,
          point: res.data.data.point,
          serviceCode: res.data.data.serviceCode,
          isAdmin: res.data.data.isAdmin,
          birthday: res.data.data.birthday,
          email: res.data.data.email,
          username: res.data.data.username,
          mobileNo: res.data.data.mobileNo,
          type: res.data.data.type,
        };
        commit("SET_USER_INFO", userInfo);
      }
    });
  },
  SET_NAVBAR({ commit }, data) {
    window.console.log("SET_NAVBAR data >>>>", data)
    commit("SET_NAVBAR", data);
  },
  SET_USER_INFO({ commit }, data) {
    commit("SET_USER_INFO", data);
  },
};

export default actions;
